import { Spacing4, ColorClubMatas1 } from 'autogen/design-tokens/tokens';
import type { CheckoutBasketDiscountInfoViewModel } from 'autogen/swagger/all';
import { UrlText } from 'autogen/translation-keys/trans-website-progressivediscount';
import Layout from 'components/Layout';
import InlineButton from 'components/generic/InlineButton';
import { Typography } from 'components/generic/typography';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import LoginActions from './LoginActions';

const StyledFlexRow = styled(Layout.Flex.Row)`
    && {
        flex-wrap: wrap;
    }
`;

const Text = styled.span`
    color: ${ColorClubMatas1};
`;

export default function ProgressiveDiscount({
    model: { progressiveDiscount, isReadOnly }
}: {
    model: CheckoutBasketDiscountInfoViewModel;
}) {
    const { t } = useTranslation();

    return (
        <StyledFlexRow gap={Spacing4} alignItems="center">
            <Typography.Body as="span" size="S" strong>
                {progressiveDiscount?.nudgeStep && (
                    <span>
                        {progressiveDiscount?.nudgeStep.triggerText} • {progressiveDiscount?.nudgeStep.savingText}
                    </span>
                )}
                {progressiveDiscount?.bestStep && progressiveDiscount?.nudgeStep && (
                    <>
                        <span> | </span>
                        <br />
                    </>
                )}
                {progressiveDiscount?.bestStep && (
                    <Text>
                        {progressiveDiscount?.bestStep.triggerText} • {progressiveDiscount?.bestStep.savingText}
                    </Text>
                )}
            </Typography.Body>

            {progressiveDiscount?.isLoginNeeded ? (
                <LoginActions />
            ) : (
                isReadOnly &&
                progressiveDiscount?.detailsLinkAction && (
                    <InlineButton
                        type="button"
                        size="sm"
                        onClick={async () => {
                            const { default: openCheckoutModal } = await import(
                                /* webpackChunkName: "openCheckoutModal" */ 'modules/progressiveDiscount/openCheckoutModal'
                            );
                            openCheckoutModal(progressiveDiscount?.detailsLinkAction?.url);
                        }}
                    >
                        {t(UrlText)}
                    </InlineButton>
                )
            )}
        </StyledFlexRow>
    );
}
